import Task from './Task';
import Requirements from './Requirements';
import { useGeneratorContext } from '@Context/GeneratorContext';
import Subtasks from './Subtasks';

interface Props {
  toggleDropdown: () => void;
}
const QueueDropdown: React.FC<Props> = ({ toggleDropdown }) => {
  const { isJiraMode } = useGeneratorContext();
  return (
    <div
      onMouseLeave={toggleDropdown}
      className="absolute z-10 flex w-full flex-col gap-y-2 rounded border border-gray-300 bg-white p-2 shadow-lg"
    >
      <ul className="custom-scroll flex max-h-72 flex-col gap-y-1 overflow-auto p-2 font-inter text-sm">
        {isJiraMode ? <Subtasks /> : <Requirements />}
        <div className="my-4 border"></div>

        <Task />
      </ul>
    </div>
  );
};

export default QueueDropdown;
